import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "SrNo", label: "Sr No" },
  { field: "DirectLabour", label: "Description" },
  { field: "DirectStore", label: "Direct Labour" },
  { field: "OnCostLabour", label: "On Cost Labour" },
  { field: "GrandTotal", label: "TOTAL" },
];


const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


export default function WGRTable({
  rows,
  shop,
  totals,
  showTotal = true,
}) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align="right"
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>




        </TableHead>

        <TableBody>
          {rows.map((row, index) => {
            let total = Number(row.PRIMECOST_LABOUR) + Number(row.Labour_On_Cost);
            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >
                <TableCell colSpan={1} align="right">{row.SrNo}</TableCell>

                <TableCell colSpan={1} align="right">{row.UNITNAME}</TableCell>

                <TableCell align="right">
                  <CurrencyCell value={row.PRIMECOST_LABOUR} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={row.Labour_On_Cost} />
                </TableCell>


                <TableCell align="right">
                  <CurrencyCell value={total} />
                </TableCell>




              </TableRow>



            );
          })}






          {showTotal && (
            <TableRow
              sx={{
                bgcolor: "primary.light",
                "& td": {
                  fontWeight: 700,
                  borderTop: "2px solid",
                  borderColor: "primary.main",
                },
              }}
            >
              <TableCell colSpan={2} align="right">
                Total Amount
              </TableCell>



              <TableCell align="right">
                <CurrencyCell value={totals.DirectLabour} />
              </TableCell>

            

              <TableCell align="right">
                <CurrencyCell value={totals.OnCostLabour} />
              </TableCell>

             
              <TableCell align="right">
                <CurrencyCell value={totals.GrandTotal} />
              </TableCell>



            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}